import React from 'react';

import { flagStyles } from '../settings';

const SvgCK = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1032px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCK;
